import Controller from '../abstracts/Controller';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'CarouselComponent',
      'FullMediaComponent',
      'QuickCategoriesComponent',
      'VideoComponent',
      'VideoBrightcove',
      'DominationComponent',
      'LookBookComponent',
      'CardComponent',
      'HeroCROComponent'
    ];
  }
}
